function tp_collection_list() {
  const tp_clc_swiper = document.querySelector('.tp__collection-swiper');
  if(!tp_clc_swiper) return;
  const slidesPerView = Number(tp_clc_swiper.dataset.desktop);
  const slidesPerViewTablets = Number(tp_clc_swiper.dataset.tablet);
  const slidesPerViewMobile = Number(tp_clc_swiper.dataset.mobile);
  const spaceBetween = Number(tp_clc_swiper.dataset.spaceBetween);
  const loop = tp_clc_swiper.dataset.loop === "true";
  const autoplay = tp_clc_swiper.dataset.autoplay === "true";

  var tp_clc_list = new Swiper('.tp__collection-swiper', {
    slidesPerView: slidesPerViewMobile,
    spaceBetween: 15,
    loop: loop,
    autoplay: autoplay,
    preventClicks: true,
    freeMode: true,
    a11y: false,
    navigation: {
      nextEl: ".swiper-next-collection",
      prevEl: ".swiper-prev-collection",
    },
    pagination: {
      clickable: true,
      el: ".swiper-pagination-collection",
    },
    breakpoints: {
      768: {
        slidesPerView: slidesPerViewTablets,
      },
      1024: {
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
      },
    }
  });
}
tp_collection_list();
document.addEventListener("shopify:section:load", tp_collection_list);
document.addEventListener("shopify:section:unload", tp_collection_list);